export default function Footer() {
    return (
        <footer className="bg-[#7a0c18] text-white mt-10">
            <div className="max-w-7xl mx-auto px-6 py-8 grid grid-cols-1 md:grid-cols-4 gap-6">

                {/* Brand Info */}
                <div>
                    <h2 className="text-xl font-bold mb-2">
                        श्री बालाजी मसाले
                    </h2>
                    <p className="text-sm text-white/90 leading-relaxed">
                        25 वर्षों से शुद्धता का विश्वास।
                        गुणवत्ता, शुद्धता और बेहतरीन स्वाद के साथ
                        हम हर रसोई तक भरोसा और खुशबू पहुँचाते हैं।
                    </p>
                </div>

                <div>
                    <h3 className="text-base font-semibold mb-3">
                        सोशल मीडिया
                    </h3>

                    <div className="flex flex-col gap-2 max-w-[220px]">

                        <a
                            href="https://facebook.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg text-sm transition"
                        >
                            📘 Facebook
                        </a>

                        <a
                            href="https://www.instagram.com/shribalajimasale2006"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 bg-gradient-to-r from-pink-500 to-yellow-500 text-white px-3 py-2 rounded-lg text-sm transition"
                        >
                            📸 Instagram
                        </a>

                        <a
                            href="#"
                            className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm transition"
                        >
                            ▶️ YouTube
                        </a>

                        <a
                            href="https://wa.me/919752772880"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-lg text-sm transition"
                        >
                            💬 WhatsApp
                        </a>

                    </div>
                </div>

                {/* Contact Info */}
                <div>
                    <h3 className="text-base font-semibold mb-3">
                        संपर्क करें
                    </h3>

                    <div className="flex flex-col gap-2 max-w-[220px]">

                        <a
                            href="tel:+919993002880"
                            className="flex items-center gap-2 bg-[#a11d2b] hover:bg-[#b32635] text-white px-3 py-2 rounded-lg text-sm transition"
                        >
                            📞 +91 9993002880
                        </a>

                        <a
                            href="tel:+919981435600"
                            className="flex items-center gap-2 bg-[#a11d2b] hover:bg-[#b32635] text-white px-3 py-2 rounded-lg text-sm transition"
                        >
                            📞 +91 9981435600
                        </a>

                        <a
                            href="tel:+919893359184"
                            className="flex items-center gap-2 bg-[#a11d2b] hover:bg-[#b32635] text-white px-3 py-2 rounded-lg text-sm transition"
                        >
                            📞 +91 9893359184
                        </a>

                    </div>
                </div>

                {/* Map */}
                <div>
                    <h3 className="text-base font-semibold mb-2">
                        हमारा पता
                    </h3>

                    <div className="rounded-lg overflow-hidden border border-white/20">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58534.894281766596!2d76.95066974863278!3d23.516999700000014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c8344628eae75%3A0xee9d35b19471a91d!2sshri%20Balaji%20Mirchi%20Bandar!5e0!3m2!1sen!2sin!4v1772251956181!5m2!1sen!2sin"
                            width="100%"
                            height="150"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Balaji Masale Location"
                        ></iframe>
                    </div>
                </div>

            </div>

            {/* Bottom Bar */}
            <div className="border-t border-white/20">
                <div className="max-w-7xl mx-auto px-6 py-3 text-center text-xs text-white/80">
                    © {new Date().getFullYear()} Balaji Masale. All Rights Reserved.
                </div>
            </div>
        </footer>
    );
}